import { UserModel } from 'src/app/models/authentication/user.model';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'user',
    standalone: false
})
export class UserPipe implements PipeTransform {

  transform(value: number, args: Array<UserModel>): string {
    let filter = args.find(x => x.userId == value)
    return filter ? filter.userName : '';
  }
}
